import { CodeSnippet } from '@backstage/core-components';
import DialogContentText from '@material-ui/core/DialogContentText';
import React from 'react';
import { sortKeys } from './util.esm.js';

function JsonPage(props) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DialogContentText, { variant: "h2" }, "Entity as JSON"), /* @__PURE__ */ React.createElement(DialogContentText, null, "This is the raw entity data as received from the catalog, on JSON form."), /* @__PURE__ */ React.createElement(DialogContentText, null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: "75%" }, "data-testid": "code-snippet" }, /* @__PURE__ */ React.createElement(
    CodeSnippet,
    {
      text: JSON.stringify(sortKeys(props.entity), void 0, 2),
      language: "json",
      showCopyCodeButton: true
    }
  ))));
}

export { JsonPage };
//# sourceMappingURL=JsonPage.esm.js.map
